// src/data/comedians/index.js
// Aggregates all comedian files and re-exports helpers.
// Add a new comedian: create src/data/comedians/<slug>.js and import it here.

import eddyMurphy      from './eddie-murphy.js';
import adelImam        from './adel-imam.js';
import charlieChaplin  from './charlie-chaplin.js';
import jimCarrey       from './jim-carrey.js';
import robinWilliams   from './robin-williams.js';
import lucilleBall     from './lucille-ball.js';
import richardPryor    from './richard-pryor.js';
import georgeCarlin    from './george-carlin.js';
import whoopiGoldberg  from './whoopi-goldberg.js';
import steveMartin     from './steve-martin.js';
import chrisRock       from './chris-rock.js';
import kevinHart       from './kevin-hart.js';
import rickyGervais    from './ricky-gervais.js';
import billBurr        from './bill-burr.js';
import aliWong         from './ali-wong.js';
import trevorNoah      from './trevor-noah.js';
import amySchumer      from './amy-schumer.js';
import hasanMinhaj     from './hasan-minhaj.js';
import johnMulaney     from './john-mulaney.js';
import boBurnham       from './bo-burnham.js';
import gadElmaleh      from './gad-elmaleh.js';
import jamelDebbouze   from './jamel-debbouze.js';
import paulMirabel     from './paul-mirabel.js';
import florenceForesti from './florence-foresti.js';
import kevAdams        from './kev-adams.js';

export const comedians = [
  ...eddyMurphy,
  ...adelImam,
  ...charlieChaplin,
  ...jimCarrey,
  ...robinWilliams,
  ...lucilleBall,
  ...richardPryor,
  ...georgeCarlin,
  ...whoopiGoldberg,
  ...steveMartin,
  ...chrisRock,
  ...kevinHart,
  ...rickyGervais,
  ...billBurr,
  ...aliWong,
  ...trevorNoah,
  ...amySchumer,
  ...hasanMinhaj,
  ...johnMulaney,
  ...boBurnham,
  ...gadElmaleh,
  ...jamelDebbouze,
  ...paulMirabel,
  ...florenceForesti,
  ...kevAdams,
];

export const getComedianBySlug = (slug, lang = 'en') =>
  comedians.find(c => c.slug === slug && c.lang === lang) ||
  comedians.find(c => c.slug === slug);

export const getAllComedianSlugs = () => [...new Set(comedians.map(c => c.slug))];

export const getComediansByLang = (lang) => comedians.filter(c => c.lang === lang);
